var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlineSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 130"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 409",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 6C11.2617 6 7 10.2617 7 15.5V19.4358C7 20.4086 7.85215 21.2 8.9 21.2H9.85C10.102 21.2 10.3436 21.0999 10.5218 20.9218C10.6999 20.7436 10.8 20.502 10.8 20.25V15.3642C10.8 15.1122 10.6999 14.8706 10.5218 14.6924C10.3436 14.5142 10.102 14.4142 9.85 14.4142H8.9874C9.5156 10.7377 12.6791 7.9 16.5 7.9C20.3209 7.9 23.4844 10.7377 24.0126 14.4142H23.15C22.898 14.4142 22.6564 14.5142 22.4782 14.6924C22.3001 14.8706 22.2 15.1122 22.2 15.3642V21.2C22.2 22.2479 21.3478 23.1 20.3 23.1H18.4V22.15H14.6V25H20.3C22.3957 25 24.1 23.2957 24.1 21.2C25.1479 21.2 26 20.4086 26 19.4358V15.5C26 10.2617 21.7383 6 16.5 6Z",
    fill: "#3F94B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineSupportIcon);
export default __webpack_public_path__ + "static/media/onlineSupportIcon.b566d7aa1848e440a3a9901bff0a7393.svg";
export { ForwardRef as ReactComponent };